export default "__VITE_ASSET__DO3G32KK__"